/* eslint-disable max-len */
import * as d3 from 'd3-color';
import { LOOP_COLOR_LIST } from '@shared/constants/theme.constant';
import { get as lodashGet } from 'lodash';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export const createDownloadFile = (data: any, filename: any) => {
  const blob = new Blob([data], { type: data.type });
  const objectUrl: string = URL.createObjectURL(blob);
  const a: HTMLAnchorElement = document.createElement(
    'a',
  ) as HTMLAnchorElement;

  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);
};

export const getColorsMap = (index: number, light = 0.26): string => {
  const color = LOOP_COLOR_LIST[index % LOOP_COLOR_LIST.length];
  const hsl = d3.hsl(color);
  hsl.l += light;
  return hsl.toString();
};

export type Lang = 'th' | 'en';

export function hasNullOrUndefinedValue(
  obj: Record<string, any>,
): boolean {
  return Object.values(obj).some(
    (value) => value === null || value === undefined,
  );
}

/**
 * Build custom search function for NgSelect.searchFn
 */
export function buildSearchByKeysFunc(
  keys: string[],
): (term: string, item: any) => boolean {
  return (term, item) => {
    term = term.toLowerCase();
    for (const key of keys) {
      const val = lodashGet(item, key, '');
      if (val.toLowerCase().indexOf(term) > -1) {
        return true;
      }
    }
    return false;
  };
}

export function parseNumberString(str: string): number {
  return Number(str.replace(/,/g, ''));
}

export function allValuesNullOrUndefined<
  T extends Record<string, any>,
>(obj: T): boolean {
  return Object.values(obj).every(
    (value) => value === null || value === undefined,
  );
}

export function compareDateStrWithNgbDate(
  fromDateStr: string | null | undefined,
  toDate: NgbDate,
): boolean {
  if (fromDateStr) {
    const _date = fromDateStr.split('-');
    const fromDate = NgbDate.from({
      day: parseInt(_date[2], 10),
      month: parseInt(_date[1], 10),
      year: parseInt(_date[0], 10),
    });
    return toDate.equals(fromDate);
  }
  return false;
}

export function isLineBrowser() {
  // sample user agent when open in Line
  //   iOS: Mozilla/5.0 (iPhone; CPU iPhone OS 18_7 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 Safari Line/26.1.1
  //   Android: Mozilla/5.0 (Linux; Android 16; SM-A536E Build/BP2A.250605.031.A3; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/144.0.7559.133 Mobile Safari/537.36 Line/26.1.1/IAB
  const userAgent = navigator.userAgent || '';
  return userAgent.includes(' Line/');
}
